import { withChildren } from "@builder.io/react";
import { trackClientEvent } from "@faire/web-api--source/trackClientEvent";
import { Button } from "@faire/web/slate/Button/Button";
import { ButtonProps } from "@faire/web/slate/Button/types";
import React from "react";

import { BuilderAttributes } from "./BuilderTypes";

const BuilderButtonBase = ({
  textContent,
  eventKeyOnClick,
  eventParams,
  attributes,
  openInNewTab,
  children,
  ...props
}: ButtonProps & {
  textContent: string;
  eventKeyOnClick: string;
  eventParams?: { param: string }[];
  attributes: BuilderAttributes;
  openInNewTab: boolean;
  children?: React.ReactNode;
}) => {
  const {
    style,
    className,
    "builder-id": builderId,
    key,
    onClick,
    ...otherAttributes
  } = attributes;

  return (
    <Button
      {...props}
      {...otherAttributes}
      style={style}
      className={className}
      key={key}
      builder-id={builderId}
      target={openInNewTab ? "_blank" : "_self"}
      onClick={(e) => {
        if (onClick) {
          onClick(e);
        }

        if (eventKeyOnClick) {
          trackClientEvent({
            eventKey: eventKeyOnClick,
            parameters: eventParams?.map(({ param }) => param),
          });
        }
      }}
    >
      {children}
      {textContent}
    </Button>
  );
};

export const BuilderButton = withChildren(BuilderButtonBase);
